export default "__VITE_PUBLIC_ASSET__ba579541__"